import { GridColumnMenu, GridColumnMenuProps } from '@mui/x-data-grid-premium';
import React from 'react';
import {
    KEY_CREDITS_COLUMN_MENU_DISPLAY_MODE_ORDER,
    KEY_CREDITS_COLUMN_MENU_MANAGE_PANEL_ORDER,
    KEY_CREDITS_COLUMN_MENU_WRAP_LIMIT_ORDER,
    KEY_CREDITS_DISPLAY_MODE
} from '../../../constants';
import type { KeyCreditsDisplayMode, KeyCreditsWrapLimit } from '../../../types';
import { isKeyCreditsColumnField } from '../../utils';
import KeyCreditsColumnMenuDisplayModeItem from './KeyCreditsColumnMenuDisplayModeItem';
import KeyCreditsColumnMenuWrapLimitItem from './KeyCreditsColumnMenuWrapLimitItem';

export interface KeyCreditsColumnMenuProps extends GridColumnMenuProps {
    displayModeColumnNames: string[];
    displayMode: Record<string, KeyCreditsDisplayMode>;
    wrapLimit: Record<string, KeyCreditsWrapLimit>;
    onDisplayModeChange: (field: string, mode: KeyCreditsDisplayMode) => void;
    onWrapLimitChange: (field: string, value: KeyCreditsWrapLimit) => void;
}

export default function KeyCreditsColumnMenu({
    displayModeColumnNames,
    displayMode,
    wrapLimit,
    onDisplayModeChange,
    onWrapLimitChange,
    ...props
}: KeyCreditsColumnMenuProps) {
    const fieldName = props.colDef?.field ?? '';
    const isKeyCreditsColumn = isKeyCreditsColumnField(fieldName, displayModeColumnNames);
    const isChipMode =
        isKeyCreditsColumn &&
        (displayMode[fieldName] ?? KEY_CREDITS_DISPLAY_MODE.lineBreak) === KEY_CREDITS_DISPLAY_MODE.chip;
    const showWrapLimitMenuItem = isKeyCreditsColumn && !isChipMode;

    return (
        <GridColumnMenu
            {...props}
            slots={
                isKeyCreditsColumn
                    ? {
                          columnMenuKeyCreditsDisplayModeItem: KeyCreditsColumnMenuDisplayModeItem,
                          ...(showWrapLimitMenuItem
                              ? { columnMenuKeyCreditsWrapLimitItem: KeyCreditsColumnMenuWrapLimitItem }
                              : {})
                      }
                    : undefined
            }
            slotProps={
                isKeyCreditsColumn
                    ? {
                          columnMenuKeyCreditsDisplayModeItem: {
                              displayOrder: KEY_CREDITS_COLUMN_MENU_DISPLAY_MODE_ORDER,
                              displayModeColumnNames,
                              displayMode,
                              onDisplayModeChange
                          },
                          ...(showWrapLimitMenuItem
                              ? {
                                    columnMenuKeyCreditsWrapLimitItem: {
                                        displayOrder: KEY_CREDITS_COLUMN_MENU_WRAP_LIMIT_ORDER,
                                        displayModeColumnNames,
                                        displayMode,
                                        wrapLimit,
                                        onWrapLimitChange
                                    }
                                }
                              : {}),
                          columnMenuManagePanelItem: {
                              displayOrder: KEY_CREDITS_COLUMN_MENU_MANAGE_PANEL_ORDER
                          }
                      }
                    : undefined
            }
        />
    );
}
